import { createSliceSelectors } from '../utils'

const SlidePanelSelectors = createSliceSelectors('slidePanel', ['isSlidePanelOpen'])

export default SlidePanelSelectors
